// meetingMapApi.js — 관리자 미팅지도 주소 묶음 (2026-10-22, 미팅지도 관리 회사별·통합 분리 2단계)
//   지도 부품(MeetingMap·훅·보관함 창)과 관리자 화면에 박혀 있던 관리자 주소를 한 곳에 모았다.
//   본사(HQ_MEETING_API) = 예전 주소 그대로. 회사별·통합은 같은 모양으로 만든다:
//     회사별  /api/admin/ext/:code/meeting-map
//     통합    /api/admin/integrated-menus/:id/meeting-map
//   설정(피드백 선택지·배너·인계 담당자)은 테넌트 공용이라 묶음에 넣지 않는다(어느 화면이든 같은 주소).

/** base 하나로 관리자 미팅지도 주소 묶음을 만든다. */
export function meetingMapApi(base, { ticketTypes, salesPeople } = {}) {
  return {
    base,                                                   // PUT {base}/:id · PATCH {base}/:id/feedback · {base}/:id/keep
    list: base,                                             // GET ?visit_date=&sales_name=
    pending: `${base}/pending-feedback`,                    // GET ?sales_name=
    keep: `${base}/keep`,                                   // GET
    ticketTypes: ticketTypes || `${base}/contract-ticket-types`,
    salesPeople: salesPeople || `${base}/sales-people`,     // 담당자 고르기 — 응답 { list: [{ id, name, ... }] }
  };
}

/** 본사 미팅지도 관리 — 예전 주소 그대로 */
export const HQ_MEETING_API = meetingMapApi('/api/admin/tm/meeting-map', {
  ticketTypes: '/api/admin/contract-ticket-types',
  salesPeople: '/api/admin/sales-people?include_resigned=false',
});
